'use client';

import { Alert, Button } from '@mui/material';
import { usePathname } from 'next/navigation';

export function PreviewBanner({ token: _token }: { token: string }) {
  const pathname = usePathname();

  return (
    <Alert
      data-component="PreviewBanner"
      severity="warning"
      sx={{
        position: 'fixed',
        right: '2%',
        top: '2%',
        zIndex: 5000,
        width: 'auto',
        opacity: 1,
        fontSize: '1.875rem',
      }}
      action={
        <Button href={`/api/disable-preview/?path=${pathname}`} color="inherit" size="small">
          Exit
        </Button>
      }
    >
      You are in Preview Mode.
    </Alert>
  );
}
